var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34b233",
    d: "M.7 13.3H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea2839",
    d: "M.7 26.7H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.3 6.7 4.5 14.7h-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.7 33.3 5-14.5L31 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.3 16.9 15.4.3-2.7 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.4 16.9-12.7 8.7-2.7-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 33.3 23.8 24l7.1-5.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.da7b917eb343a7a13d0f9c72c5e3059a.svg";
export { ForwardRef as ReactComponent };